define('treeOfContent/treeNodes/TreeNode',[], function() {
    return function(id, title) {
        this.id = id;
        this.title = title;
    };
});
